import { Box, Typography, styled } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { DynamicIntlProvider } from "@/shared/components/DynamicIntlProvider";

import Localization from "../../../shared/services/Localization.service";
import { clearAllUserData } from "../../services/auth/Auth.service";
import { PrimaryButton } from "../buttons/primary-button/primary-button";

const Root = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  gap: 16,
});

const NoFarmsScreen = () => (
  <DynamicIntlProvider locale={Localization.getLang()}>
    <Root>
      <Typography fontWeight={500} variant="h5">
        <FormattedMessage id="NoFarms.title" />
      </Typography>
      <Typography color="text.secondary">
        <FormattedMessage id="NoFarms.message" />
      </Typography>
      <PrimaryButton
        variant="outlined"
        onClick={() => {
          clearAllUserData();
          window.location.href = "/login";
        }}
      >
        <FormattedMessage id="UserMenu.logout" />
      </PrimaryButton>
    </Root>
  </DynamicIntlProvider>
);

export { NoFarmsScreen };
